import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { ShoppingBag } from "@phosphor-icons/react";

export default function CallbackFlow({ slug, bizName }) {
  const [form, setForm] = useState({ name: "", phone: "", note: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/public/callback/${slug}`, form);
      setSent(true);
      toast.success("Sent — someone will call you back shortly");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to send");
    }
    setBusy(false);
  };

  if (sent) {
    return (
      <div className="paper-card p-8 mt-4 text-center">
        <ShoppingBag size={40} color="#1E3A2F" className="mx-auto mb-3" />
        <h2 className="text-2xl mb-2">Got it, {form.name}!</h2>
        <p className="text-[#5C6B61]">A team member from {bizName} will call you back at {form.phone} shortly to take your to-go order.</p>
      </div>
    );
  }

  return (
    <div className="paper-card p-6 mt-4">
      <div className="overline mb-1">To-go orders</div>
      <h3 className="text-xl mb-2">We take to-go orders by phone.</h3>
      <p className="text-sm text-[#5C6B61] mb-4">Leave your number and a team member will call you back — usually within a few minutes — to take your order directly. That way it lands straight on the kitchen line with no double-entry.</p>
      <form onSubmit={submit} className="space-y-3">
        <div>
          <label className="overline block mb-1">Your name</label>
          <input required className="input-field" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="callback-name" />
        </div>
        <div>
          <label className="overline block mb-1">Mobile phone</label>
          <input required className="input-field" placeholder="+15555550100" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="callback-phone" />
          <p className="text-[11px] text-[#5C6B61] mt-1 leading-snug">By requesting a callback you consent to receive a call and text messages from this business about your order. Msg &amp; data rates may apply. Reply <b>STOP</b> to opt out.</p>
        </div>
        <div>
          <label className="overline block mb-1">Note (optional)</label>
          <input className="input-field" placeholder="Best time to reach me, dietary needs, etc." value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} data-testid="callback-note" />
        </div>
        <button disabled={busy} className="btn-primary w-full justify-center" data-testid="callback-submit">
          {busy ? "Sending…" : "Request a callback"}
        </button>
      </form>
    </div>
  );
}
